import { useTranslates } from 'providers/translates';
import { CreateMemorialSteps } from '../CreateMemorialSteps';
import styles from './styles.module.scss';

type Props = {
  isContributor?: boolean;
  isStepOne?: boolean;
  isStepTwo?: boolean;
  showDialogBlocks?: () => Promise<void>;
  onSave: () => Promise<void>;
  isActiveStep: number;
  steps: {
    index: number;
    title: string;
  }[];
};

const CreateMemorialFooter: React.FC<Props> = ({
  isContributor,
  isStepOne,
  isStepTwo,
  showDialogBlocks,
  onSave,
  isActiveStep,
  steps
}) => {
  const { translates: t } = useTranslates();
  return (
    <>
      {(isStepTwo || isStepOne) && (
        <div className={`delimitierGrey ${isStepOne ? styles.stepOneSeparator : styles['separator-gap']}`}></div>
      )}
      <div
        className={`${styles.actions} ${isStepOne ? styles.stepOneTopMargin : styles.anotherStepTopMargin} ${isContributor ? styles.actionIsContributor : ''} ${isStepTwo ? styles.stepTwoDirection : styles.anotherStepDirection}`}
      >
        <div className={styles.actions__right}>
          <button 
            className={`customButton ${styles.actions__button}`} 
            onClick={onSave}
          >
            {t?.quiltBuilder?.builderFooter?.saveAndContinueButtonLabel ?? 'Save and Continue'}
          </button>
          {!isStepTwo && (
            <button 
              className={`customButton ${styles.actions__button}`} 
              onClick={showDialogBlocks}
            >
              {t?.quiltBuilder?.builderFooter?.previewButtonLabel ?? 'Preview'}
            </button>
          )}
        </div>
        <div
          className={`${styles.actions__left} ${isContributor ? styles.actionLeftIsContributor : ''}`}
        >
          {!isContributor && (
            <CreateMemorialSteps 
              isActiveStep={isActiveStep} 
              steps={steps} 
            />
          )}
        </div>
      </div>
    </>
  );
}

export { CreateMemorialFooter };
